export default __webpack_public_path__ + "static/media/file-document-edit-outline.5293a41c.svg";